<template>   
  
  <Nav />
  <div class="relative">
    <div tabindex="1" @click="menuOpenClose(false)" class="mobile-menu">
          <q-icon :name="menuIcon" />
      </div>
      <div v-if="mobileMenuToggle" class="mobile-nav-container">
        <div class="mobile-nav-container-options">
          <NavOptions @closeMenu="menuOpenClose" />
        </div>
      </div>
      <router-view />
  </div>
  <Footer />
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import Nav from "./components/Nav.vue"
import NavOptions from "./components/NavOptions.vue"
import Footer from './components/Footer.vue'
import { useRoute } from "vue-router";

const route = useRoute()

const mobileMenuToggle = ref(false)

const menuIcon = computed( () => {
  return mobileMenuToggle.value === true ? 'close' : 'menu'
})

const menuOpenClose = (anchor) => {

mobileMenuToggle.value = !mobileMenuToggle.value 

if(anchor) {
// document.body.scrollTop = 0;
  document.getElementById(anchor).scrollIntoView({behavior: "smooth"});
}

if(mobileMenuToggle.value === true) {
// document.querySelector("body").style.height = '100%';
  document.querySelector("body").style.overflowY = 'hidden';

} else {
  // document.querySelector("body").style.height = 'auto';
  document.querySelector("body").style.overflowY = 'visible';
  document.querySelector("body").style.overflowY = 'scroll';
} 
}


</script>
